var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconListBulleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17a3 3 0 110 6 3 3 0 010-6zm20 2a1 1 0 01.117 1.993L23 21H9a1 1 0 01-.117-1.993L9 19h14zM3 19a1 1 0 100 2 1 1 0 000-2zM3 9a3 3 0 110 6 3 3 0 010-6zm20 2a1 1 0 01.117 1.993L23 13H9a1 1 0 01-.117-1.993L9 11h14zM3 11a1 1 0 100 2 1 1 0 000-2zM3 1a3 3 0 110 6 3 3 0 010-6zm20 2a1 1 0 01.117 1.993L23 5H9a1 1 0 01-.117-1.993L9 3h14zM3 3a1 1 0 100 2 1 1 0 000-2z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconListBulleted;